import React, { useState } from 'react';

import VideoIcon from '@rover/icons/svg/video.svg';
import { Box, Button, Flex, Heading, Paragraph } from '@rover/kibble/core';
import {
  FlexboxSystemProps,
  LayoutSystemProps,
  MarginSystemProps,
} from '@rover/kibble/core/styledSystemPropTypes';
import useTheme from '@rover/kibble/themes/useTheme';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import { TrainerProfileVirtualTrainingBoxClicked } from '../../../events/analyticsEvents';

import { VirtualTrainingModal } from './VirtualTrainingModal';

type VirtualTrainingBoxProps = {
  shortName: string;
} & LayoutSystemProps &
  MarginSystemProps &
  FlexboxSystemProps;

const VirtualTrainingBox = ({
  shortName,
  display,
  mb = '0x',
  mt = '0x',
  flexDirection = 'column',
}: VirtualTrainingBoxProps): JSX.Element => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleOnClick = (): void => {
    emitAnalyticsEvent(new TrainerProfileVirtualTrainingBoxClicked());
    setIsOpen(true);
  };

  return (
    <Flex
      flexDirection={flexDirection}
      pt="4x"
      px="4x"
      pb="2x"
      mt={mt}
      mb={mb}
      gap="2x"
      sx={{ backgroundColor: theme.colors.orange[100] }}
      borderRadius="8px"
      display={display}
    >
      <Flex gap="4x" flex="1">
        <Box>
          <VideoIcon width={theme.sizes['6x']} height={theme.sizes['6x']} />
        </Box>
        <Flex flexDirection="column" gap="2x" flex="1">
          <Heading mb="0x">{shortName} is a virtual trainer</Heading>
          <Paragraph size="100" mb="2x">
            Train through video calls with a professional dog trainer wherever you are.
          </Paragraph>
        </Flex>
      </Flex>
      <Flex height="100%" justifyContent="center">
        <Button
          variant="default"
          onClick={handleOnClick}
          data-testid="virtual-training-steps-button"
        >
          What do I need for virtual training?
        </Button>
      </Flex>
      <VirtualTrainingModal isOpen={isOpen} setIsOpen={(open: boolean) => setIsOpen(open)} />
    </Flex>
  );
};

export default VirtualTrainingBox;
